export const delete_icon_color = 'rgb(228, 36, 36)';
export const version = "0.1.0";
export const states = 'https://countriesnow.space/api/v0.1/countries/states';

export const admin_login_url = "/ip-salogin"


